import { TableCell, TableRow } from '@mui/material';
import { FunctionComponent } from 'react';
import { ISecrEmissionData } from '../../../../shared/services/generated-report/generated-report.model';
import { ReportingSecrTableSegment } from './reporting-secr-table-segment';
import { emptyEmissionData } from './secr-summary-table.utils';

export const ReportingSecrTableRow: FunctionComponent<{
  title: any,
  primaryData: ISecrEmissionData | undefined | null,
  comparisonData: (ISecrEmissionData | undefined | null)[],
  showOverseas: boolean,
}> = ({
  title,
  primaryData,
  comparisonData,
  showOverseas,
}) => {
    const primary = primaryData ?? emptyEmissionData();
    return (
      <TableRow>
        <TableCell
          scope='row'
          sx={{ wordBreak: 'break-word', overflowWrap: 'anywhere', verticalAlign: 'middle', py: 0.55 }}
        >
          {title}
        </TableCell>
        <ReportingSecrTableSegment
          backgroundColor='secondary.light'
          data={primary}
          showOverseas={showOverseas}
        />
        {comparisonData.map((data, index) => (
          <ReportingSecrTableSegment
            key={index}
            backgroundColor='white'
            data={data ?? emptyEmissionData()}
            showOverseas={showOverseas}
          />
        ))}
      </TableRow>
    )
  }